var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideDiagnostics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: 23,
    height: 23,
    viewBox: "0 0 512 512",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 210.464,
    y: 46.307,
    transform: "matrix(-0.8935 -0.449 0.449 -0.8935 417.2299 376.1477)",
    width: 85.498,
    height: 184.595
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.863,
    y: 313.827,
    width: 134.1,
    height: 34.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.663,277.327c0-60.6-31.9-113.9-79.7-143.8l-18.7,36.9c34.6,23,57.6,62.2,57.6,106.9c0,70.7-57.5,128.2-128.2,128.2 c-34.6,0-65.7-13.6-88.6-35.7h-53.2c16.3,24.9,39.2,45.5,66.1,58.7h-38.1v61h225.8v-61h-35.7 C367.563,400.927,405.663,343.427,405.663,277.327z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.843,
    y: 7.844,
    transform: "matrix(-0.8935 -0.449 0.449 -0.8935 555.6599 173.8512)",
    width: 41.199,
    height: 26.399
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.894,
    y: 240.196,
    transform: "matrix(0.449 -0.8935 0.8935 0.449 -106.2222 341.1332)",
    width: 13.2,
    height: 32.999
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.474,
    y: 225.818,
    transform: "matrix(-0.8935 -0.4491 0.4491 -0.8935 225.362 525.2878)",
    width: 33.001,
    height: 20.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideDiagnostics);
export default __webpack_public_path__ + "static/media/sideDiagnostics.cebd0efca9a5e572342438e8e0e1bd83.svg";
export { ForwardRef as ReactComponent };